import Vue from 'vue'
import Router from 'vue-router'
import Home from '../pages/Home.vue'
import Features from '../pages/Features.vue'
import Contact from '../pages/Contact.vue'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/features',
            name: 'Features',
            component: Features
        },
        {
            path: '/contact',
            name: 'Contact',
            component: Contact
        },
        { path: '*', redirect: '/' }
        // {
        //   path: '/author/add',
        //   name: 'authorManage',
        //   component: authorManage
        // },
        // {
        //   path: '/author/edit/:id',
        //   name: 'authorManage',
        //   component: authorManage
        // },
        // {
        //   path: '/demo',
        //   name: 'demo',
        //   component: Demo,
        //   children: [
        //     { path: '', component: DemoHome },
        //     { path: 'child/:id', component: DemoChild }
        //   ]
        // }
    ]
})
